import React from "react";

const User = ({style = {}, size = "36", className = "", fill = "#73788B", viewBox = "0 0 36 36"}) => (
    <svg
        width={size}
        style={style}
        height={size}
        viewBox={viewBox}
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={`${className || ""}`}
        xmlnsXlink="http://www.w3.org/1999/xlink"
    >
      <path className="u_fill"
          d="M6 34a12.29 12.29 0 013.515-8.62A11.906 11.906 0 0118 21.81c3.183 0 6.235 1.284 8.485 3.57A12.29 12.29 0 0130 34H6zm12-13.714c-4.973 0-9-4.092-9-9.143C9 6.09 13.027 2 18 2s9 4.091 9 9.143c0 5.051-4.027 9.143-9 9.143z"
          fill={fill}
      />
    </svg>
);

export default User;
